export enum DefaultValueEnum {
    CurrentTime = "CurrentTime",
    CurrentDate = "CurrentDate"
}